module.exports = __webpack_public_path__ + "static/college_of_creation-ce62b9bd5a2db78f059f8362f22811df.png";